<template>
  <div id="multicastGroup">
    <nav-tabs-extended>
      <template slot="meta-bar-left">
        <span class="multicast-group-name">{{ multicastGroup.name }}</span>
        <span class="ml-4">{{ multicastGroup.mcAddr }}</span>
      </template>

      <template slot="meta-bar-right">
        <span class="ml-lg-4 d-none d-lg-block">{{ multicastGroup.cluster ? multicastGroup.cluster.name : '' }}</span>
      </template>

      <template slot="tabs-bar">
        <div class="nav-item"><router-link id="multicastGroupOverviewLink" :to="{name: 'multicastGroupOverview', params: {id}}" class="nav-link">{{ $t('mcg-multicastGroup:overview') | capitalize }}</router-link></div>
        <div class="nav-item"><router-link id="multicastDataDownLink" :to="{name: 'multicastDataDown', params: {id}}" class="nav-link">{{ $t('mcg-multicastGroup:dataDown') | capitalize }}</router-link></div>
      </template>
    </nav-tabs-extended>

    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import eventBus from '@/modules/eventBus'

export default {
  props: {
    id: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapGetters(['multicastGroup'])
  },

  watch: {
    id () {
      this.getMulticastGroup()
    }
  },

  created () {
    if (this.id !== this.multicastGroup.id) {
      this.$store.commit('setMulticastGroup', {})
    }

    this.getMulticastGroup()
  },

  methods: {
    getMulticastGroup () {
      this.$store.dispatch('getMulticastGroup', this.id)
        .then(() => {
          this.$store.commit('addLastViewedMulticastGroup', this.multicastGroup)
        })
        .catch((e) => {
          if (e.response && e.response.status === 404) eventBus.$emit('request:404')
          if (e.response && e.response.status === 403) eventBus.$emit('request:403')
        })
    }
  }
}
</script>

<style scoped lang="scss">
  .multicast-group-name {
    max-width: 20vw;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>
